export const schemaPanelStyles = {
  panel: {
    width: '40%',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    backgroundColor: 'custom.surfaceAlt',
    minHeight: 400,
    maxHeight: 800,
    alignSelf: 'stretch',
  },
  header: { px: 2, pt: 2, pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' },
  title: { mb: 1.5 },
  filters: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 },
  filterSelect: {
    '& .MuiOutlinedInput-root': {
      fontSize: 13,
      minHeight: 34,
      borderRadius: 1.5,
      '& fieldset': { borderColor: 'divider' },
      '&:hover fieldset': { borderColor: 'text.secondary' },
      '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: 1 },
    },
    '& .MuiInputLabel-root': { fontSize: 13 },
  },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 0.5 },
  clearButton: {
    width: 'fit-content',
    justifySelf: 'end',
    color: 'text.secondary',
    textTransform: 'none',
    gridColumn: '2',
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      fontSize: 13,
      height: 34,
      borderRadius: 1.5,
      '& fieldset': { borderColor: 'divider' },
      '&:hover fieldset': { borderColor: 'text.secondary' },
      '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: 1 },
    },
  },
  searchIcon: { fontSize: 16, color: 'text.secondary' },
  list: { flex: 1, overflowY: 'auto', p: 1 },
  centered: { display: 'flex', justifyContent: 'center', py: 3 },
  spinner: { color: 'secondary.main' },
  message: { p: 1, display: 'block', color: 'text.secondary' },
  errorMessage: { p: 1, display: 'block', color: 'error.main' },
};
